export const SDR_TEAM = 'SDR Team';
export const CS_TEAM = 'CS Team';
export const USA_EAST_COAST = 'USA | East coast';
export const USA_WEST_COAST = 'USA | West coast';
